export const SPANISH_LOCALE = {
  firstDayOfWeek: 1,
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
  monthNames: [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ],
  monthNamesShort: [
    'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
    'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
  ],
  today: 'Hoy',
  clear: 'Limpiar',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  fileUpload: {
    invalidFileTypeSummary: '{0}: Tipo de archivo no válido.',
    invalidFileSizeSummary: '{0}: Tamaño de archivo no válido',
    invalidFileTypeDetail: 'Tipos de archivo permitidos: PDF, XLS, XLSX',
    invalidFileTypeExcelDetail: 'Tipos de archivo permitidos: XLS, XLSX',
    invalidFileSizeDetail: 'El tamaño máximo permitido es 1MB',
    invalidFileTypeDetailTreasury: 'Tipos de archivo permitidos: JPEG, JPG, PNG, PDF',
    invalidFileSizeDetailTreasury: 'El tamaño máximo permitido es 5MB'
  }
};